<template>
<div>
  <MobileNavigationBack :appbarTitle="appbarTitle"></MobileNavigationBack>
  <div class="mt-5 p-2 grey-background-container">

   <!-- <h4 class="pt-2">Your Organisations</h4>
    <div class="grid grid-cols-2 gap-4">
      <a class="bg-green-400 p-4 rounded-lg shadow text-center no-decoration">
        <span class="text-white">Organisation</span>
        <i class="fas fa-check-circle text-white ml-2"></i>
      </a>
      <a class="bg-green-400 p-4 rounded-lg shadow text-center no-decoration">
        <span class="text-white">Organisation</span>
      </a>

    </div> --> 
    <h4 class="pt-2">More Options</h4>
    <div class="grid grid-cols-3 gap-4">
      <a v-on:click="openPunchMapScreen()" class="bg-green-400 p-4 rounded-lg shadow text-center no-decoration">
        <i class="fas fa-calendar-check text-white text-2xl"></i> <br>
        <span class="text-white">Attendance</span>
      </a>
      <a v-bind:href="'/app/paytime/attendance-leaves-summary'" class="home-menu-box  justify-center bg-green-400 p-4 rounded-lg shadow text-center no-decoration">
        <i class="fas fa-receipt text-white text-2xl"></i> <br>
        <span class="text-white">Summary</span>
      </a>
      <a  v-bind:href="'/app/paytime/expense-selection'" class="home-menu-box bg-green-400 p-4 rounded-lg shadow text-center no-decoration">
        <i class="fas fa-shopping-cart text-white text-2xl"></i> <br>
        <span class="text-white">Expenses</span>
      </a>
      <a class="home-menu-box bg-green-400 p-4 rounded-lg shadow text-center no-decoration">
        <i class="fas fa-users text-white text-2xl"></i> <br>
        <span class="text-white">Self Service</span>
      </a>
      <a class="home-menu-box bg-green-400 p-4 rounded-lg shadow text-center no-decoration">
        <i class="fas fa-bell text-white text-2xl"></i> <br>
        <span class="text-white">Notification</span>
      </a>
      <a class="home-menu-box bg-green-400 p-4 rounded-lg shadow text-center no-decoration">
        <i class="fas fa-comments text-white text-2xl"></i> <br>
        <span class="text-white">Chat</span>
      </a>

    </div>
  </div>
  </div>
</template>
<style scoped>
    .noselect {
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Safari */
        -khtml-user-select: none;
        /* Konqueror HTML */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }

    .no-decoration{
      text-decoration: none;
    }

    
.grey-background-container{
  background-color:#F3F4F6;
  height:100vh;
}

    .no-decoration:hover{
      text-decoration: none;
    }

    #attendanceOrLeaves{
     margin-bottom: 10px;
     border-radius: 10px;
     margin-left: 10px;
     margin-top: 10px;
    }

.border-t-1{
    border-top: 1px solid gray;
}
#container {
  width: 100%;
  height: 100%;
  margin-top: 20%;
/* --- FLEX --- */
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu-box {
  width: 100%;
  height: 100%;
  font-size: 20px;
  color: #333;
  text-align: center;
  border-radius: 3px;
  display: inherit;
  justify-content: inherit;
  align-items: inherit;
  transition: all 0.5s ease;
}

.home-menu-box{
  min-height:100px;
  height:110px;

}

/* Just common table stuff. Really. */
table  { border-collapse: collapse; width: 100%; }

    </style>

<script>
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from '@/Jetstream/NavLink.vue'
import MobileNavigationBack from "@/Layouts/MobileNavigationBack.vue";


export default {
  props: ["sessions"],

  components: {
    Welcome,
    PageTitle,
    JetNavLink,
    MobileNavigationBack,
  },
  data() {
    return {
      title: "Attendance Summary",
      username: null,
      appbarTitle: "Paytime",
      password: null,
    };
  },
  mounted() {
    window.getCoordinates = this.getCoordinates;

    this.initView();
  },
  methods: {
     onChange(event){

       if (event.target.value==='leaves'){
          document.getElementById('attendanceContainer').style.display = "none";
          document.getElementById('leavesContainer').style.display = "block";
          // getLeavesData();

       }else if (event.target.value==='attendance'){
          document.getElementById('attendanceContainer').style.display = "block";
          document.getElementById('leavesContainer').style.display = "none";
          // getAttendanceData();
       }
      //  console.log(event.target.value);
    }
,
    initView() {
      document.getElementById('attendanceContainer').style.display = "block";
      document.getElementById('leavesContainer').style.display = "none";
      
      document.getElementById("mobile-menu-checkbox").checked = false;
      closeDrawer();
    },
     closeDrawer() {
        // document.getElementById("mobile-menu-checkbox").checked = false;
        alert("hello");
    },

    openPunchMapScreen(){
      console.log("Open Punch Screen");
      app.startPunchMap();
    },
    getCoordinates(longitude,latitude){
       alert(longitude+"::"+latitude);
    }
  }
};

</script>
